<template>
  <ux-button
    :class="['x-margin-l get-code', { 'get-code-text': text }, { disabled: isCountdowning }]"
    size="mini"
    :text="text"
    :disabled="dataTime === time ? false : true"
    @click="click"
    >{{ dataContent }}</ux-button
  >
</template>

<script>
import i18n from '@/i18n/index.js';

export default {
  name: 'TimeButton',
  props: {
    time: {
      // 30秒
      type: Number,
      default: 30
    },
    content: {
      // 内容
      type: String,
      default: () => i18n.t('HT.timeButton.getcode')
    },
    text: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dataTime: this.time,
      dataContent: this.content,
      timer: null,
      isCountdowning: false // 倒计时中
    };
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.end();
  },

  methods: {
    click() {
      this.$emit('click');
    },

    /**
     * 结束计时状态
     */
    end() {
      this.dataContent = this.content;
      this.dataTime = this.time;
      this.isCountdowning = false;
    },

    /**
     * 开始倒计时
     */
    start() {
      clearInterval(this.timer);
      this.end();
      this.dataContent = `${this.$t('HT.timeButton.renew')}(${this.dataTime})`;
      this.isCountdowning = true;
      this.timer = setInterval(() => {
        this.dataTime--;
        this.dataContent = `${this.$t('HT.timeButton.renew')}(${this.dataTime})`;
        if (this.dataTime == 0) {
          clearInterval(this.timer);
          this.end();
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.get-code-text {
  color: $color-primary;

  &.disabled {
    color: $color-text-disable;
  }
}
</style>
